import { Navigate } from "react-router-dom";

import { useContentAccess } from "utils/hooks/useContentAccess";

import CompleteCoursePage from "./index";

/**
 * AIDEV-NOTE: `/kompletni-kurz` je bez tohohle guardu v userRouter.tsx otevřená i vpisovanou
 * URL. Pouští dál jen `"upgrade"` — light maturant si stránku legitimně otevírá kvůli koupi.
 * `"hidden"` (deváťák/páťák, kterému to Zóna neprodá) i `"granted"` posílá na nástěnku.
 * `"granted"` schválně stejně jako `"hidden"`: stránka je od TD-374 prodejní (tlačítko
 * „Koupit Kompletní kurz" a doplatek), ne jen informativní jako dřív. Maturant, který
 * klikne na CTA, zaplatí v Zóně a vrátí se do panelu s obnovenou aplikací, má z GraphQL
 * `fullAccess: true`, tedy `"granted"` — kdyby ho guard pustil dál, koukal by na tutéž
 * nabídku k nákupu, kterou právě zaplatil, a nic by mu neřeklo, že to prošlo. Signál
 * "koupeno" nese nástěnka (odemčené položky v menu). [TD-351, TD-374]
 */
export const CompleteCourseGuard = () => {
  const { graduationAccess } = useContentAccess();

  if (graduationAccess !== "upgrade") return <Navigate to="/" replace />;

  return <CompleteCoursePage />;
};
